import { UserRole } from './user-role';
import { UserStatus } from './user-status';

export interface User {
  id: number;
  email: string;
  userName: string;
  fullName: string;
  birthDate: string;
  phone: string;
  status: UserStatus;
  role: UserRole;
}

export type UserSignUpDto = Pick<User, 'email' | 'phone' | 'userName' | 'fullName'> & {password: string};
export type UserLoginDto = Pick<User, 'email' > & {password: string};
export type UserSignUp = User;
export type UserSignIn = Omit<User, 'status' | 'role'>;
export type UserSignInResponse = { accessToken: string; refreshToken: string } & { user: UserSignIn };
export type UserUpdate = Pick<User, 'email' | 'birthDate' | 'fullName' | 'userName'>;

export interface ResetPassword {
  message: string;
  requestId: string;
}

export const defaultUser: UserSignIn = {
  id: 0,
  email: '',
  userName: '',
  fullName: '',
  birthDate: '',
  phone: '',
}
